import React, { useState, useEffect,useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { UserContext } from "../App";
import { formatDateIntoDDMMYY, isNullUndefine } from "../control/Constant";
import config from "../config.json";
import Services from "../network/Services";

// ─── Helpers ────────────────────────────────────────────────────────────────

const getItemPath = (item) => item.path || (item.Link || "").split("?")[0];

const normalizeMenuItems = (items) =>
  items.map((item) => {
    if (!item.children || item.children.length <= 1) {
      const { children, ...flatItem } = item;
      return flatItem;
    }
    return item;
  });

const FIRM_PARTNER_PATH = "/FirmPartner";
const FIRM_DEFAULT_VIEW = "1";

const getViewFromChildLink = (link) => {
  const query = link.split("?")[1];
  return query ? new URLSearchParams(query).get("view") : null;
};

const getFirmSectionChildren = (rId,id,isShow) => {
      const children = [];
  if (rId == 4 && id != 2) {
    children.push({ name: "Firms", Link: "/FirmPartner?view=1" });
  }
  // if(id != 2){
    children.push({ name: rId == 4 ? "Firm Users" : "Staff Members", Link: "/FirmPartner?view=2"});
  // }
  // if(rId != 4 && isShow){
    children.push({ name: "Staff Schedule Planner", Link: "/FirmPartner?view=3" });
    children.push({ name: "Compensation Configuration", Link: "/FirmPartner?view=9" });
    if (rId == 4 && isShow) {
      children.push({ name: "Know Your User", Link: "/FirmPartner?view=6" });
      // children.push({ name: "File Cabinet", Link: "/FirmPartner?view=7" });
    }
  // }
  return children;
};

const getFirmParentFromItems = (items) =>
  items.find((item) => getItemPath(item) === FIRM_PARTNER_PATH);

const getFirmActiveChild = (items, search) => {
  const firmParent = getFirmParentFromItems(items);
  if (!firmParent?.children?.length) return null;
  const view = new URLSearchParams(search).get("view") || FIRM_DEFAULT_VIEW;
  const matched = firmParent.children.find(
    (child) => String(getViewFromChildLink(child.Link)) === String(view)
  );
  return matched || firmParent.children[0];
};

const getFileCabinetChildren = (rId) => {
  if (rId == 4) {
    return [
      // { name: "Manage File Cabinet", Link: "/newFilecabinet?view=1" },
      { name: "Manage File Cabinet", Link: "/FirmPartner?view=7"},
      { name: "Assign Cabinet", Link: "/newFilecabinet?view=2" },
    ];
  }
  return [{ name: "File Cabinet", Link: "/newFilecabinet" }];
};

const getProductManagementChildren = (rId) => {
  const children = [{ name: "Product Management", Link: "/ProductManagement?view=1" }];
  if (rId == 4) {
    children.push({ name: "Pricing", Link: "/ProductManagement?view=2" });
  }
  return children;
};

const buildSuperAdminMenu = (rId,id,isShow) => [
  {
    name: "My Firms",
    icon: "/firm.svg",
    id: 2,
    Link: "/FirmPartner?view=1",
    path: "/FirmPartner",
    children: getFirmSectionChildren(rId,id,isShow),
  },
  // {
  //   name: "Clients",
  //   icon: "/ClientAi.svg",
  //   id: 15,
  //   Link: "/AllClients",
  //   path: "/AllClients",
  //   // children: getFirmSectionChildren(rId),
  // // },
  // // ...(isShow == true ? [
  //   {
  //   name: "Event Management",
  //   icon: "/seminars.svg",
  //   id: 3,
  //   Link: "/SeminarFile",
  //   path: "/SeminarFile",
  //   children: [
  //     { name: "Publish Seminar", Link: "/SeminarFile?view=1" },
  //     { name: "Published Seminar", Link: "/SeminarFile?view=2" },
  //   ],
  // },
// ] : []),
  // ...(isShow == false ? [
    {
    name: "Communications/Content",
    icon: "/communication.svg",
    id: 11,
    Link: "/communication",
    path: "/communication",
  }
// ] : [])
,
  // ...(id != 2 ? [{
  //   name: "Workshop",
  //   icon: "/agentmodule.svg",
  //   id: 4,
  //   Link: "/Classroom",
  //   path: "/Classroom",
  //   children: [
  //     { name: "Publish Workshop", Link: "/Classroom?view=1" },
  //     { name: "Published Workshop", Link: "/Classroom?view=2" },
  //   ],
  // }] : []),
  {
    name: "Product Management",
    icon: "/projectmanamnt.svg",
    id: 5,
    Link: "/ProductManagement",
    path: "/ProductManagement",
    children: getProductManagementChildren(rId),
  },
  {
    name: "File Cabinet",
    icon: "/filabinate.svg",
    id: 6,
    Link: "/newFilecabinet",
    path: "/newFilecabinet",
    children: getFileCabinetChildren(rId),
  },
  {
    name: "Academy Users",
    icon: "/images/AOoutlined.svg",
    id: 8,
    Link: "/academyUsers",
    path: "/academyUsers",
  },
  {
    name: "Strategic Partners",
    icon: "/partner_exchange.svg",
    id: 9,
    Link: "/Professional",
    path: "/Professional",
  },
  {
    name: "Case Management",
    icon: "/images/products-black.svg",
    id: 12,
    Link: "/productsAndPlans",
    path: "/productsAndPlans",
  },
  // {
  //   name: "Document Management",
  //   icon: "/images/document_management.svg",
  //   id: 16,
  //   Link: "/documentManagement",
  //   path: "/documentManagement",
  //  },
  // {
  //   name: "Agent Module",
  //   icon: "/images/support_agent.svg",
  //   id: 20,
  //   Link: "/agentsModule",
  //   path: "/agentsModule",
  //  },
  {
    name: "Feedback",
    icon: "/feedback.svg",
    id: 7,
    Link: "/Feedback",
    path: "/Feedback",
  },
];

const buildFirmAdminMenu = (rId,id,isShow) => [
  {
    name: "My Firm",
    icon: "/firm.svg",
    id: 10,
    Link: "/FirmPartner?view=1",
    path: "/FirmPartner",
    children: getFirmSectionChildren(rId,id,isShow),
  },
   {
    name: "Clients",
    icon: "/ClientAi.svg",
    id: 15,
    Link: "/AllClients",
    path: "/AllClients", 
    children: [
      { name: "Client List", Link: "/AllClients" },
      { name: "Workshop Analytics", Link: "/AllClients", analyticsAction: true },
    ],
  },
  {
    name: "Event Management",
    icon: "/seminars.svg",
    id: 3,
    Link: "/SeminarFile",
    path: "/SeminarFile",
    children: [
      { name: "Publish Seminar", Link: "/SeminarFile?view=1" },
      { name: "Published Seminar", Link: "/SeminarFile?view=2" },
    ],
  },
  {
    name: "Communications/Content",
    icon: "/communication.svg",
    id: 11,
    Link: "/communication",
    path: "/communication",
  },
  // {
  //   name: "Product Management",
  //   icon: "/projectmanamnt.svg",
  //   id: 5,
  //   Link: "/ProductManagement",
  //   path: "/ProductManagement",
  //   children: getProductManagementChildren(rId),
  // },
  
  ...(isShow == true && (id == 2 || id == 742) ? [{
    name: "Document Management",
    icon: "/images/document_management.svg",
    id: 16,
    Link: "/documentManagement",
    path: "/documentManagement",
  }] : []),
  {
    name: "File Cabinet",
    icon: "/filabinate.svg",
    id: 6,
    Link: "/newFilecabinet",
    path: "/newFilecabinet",
    children: getFileCabinetChildren(rId),
  },
  {
    name: "Case Management",
    icon: "/images/products-black.svg",
    id: 12,
    Link: "/productsAndPlans",
    path: "/productsAndPlans",
    disabled: rId != 4,
  },
  // ...((() => {
  //   try {
  //     const detail = JSON.parse(sessionStorage.getItem('userLoggedInDetail') || '{}');
  //     return detail?.userName === 'amitkinha201615@maildrop.cc';
  //   } catch { return false; }
  // })() ? [{
  //   name: "Agent Module",
  //   icon: "/images/support_agent.svg",
  //   id: 20,
  //   Link: "/agentsModule",
  //   path: "/agentsModule",
  //  }] : []),
   ...(config.demo === true ? [{
    name: "Agent Module",
    icon: "/images/support_agent.svg",
    id: 20,
    Link: "/agentsModule",
    path: "/agentsModule",
   }] : []),
  {
    name: "Feedback",
    icon: "/feedback.svg",
    id: 7,
    Link: "/Feedback",
    path: "/Feedback",
  },
];

const getActiveFromRoute = (pathname, search, rId) => {
  const view = new URLSearchParams(search).get("view");
  if (pathname === FIRM_PARTNER_PATH) {
  if (view === "7") {
    return "Manage File Cabinet";
  }
  const children = getFirmSectionChildren(rId);
  const viewKey = view || FIRM_DEFAULT_VIEW;
  const matched = children.find(
    (child) => String(getViewFromChildLink(child.Link)) === String(viewKey)
  );
  return (matched || children[0]).name;
}
  if (pathname === "/SeminarFile") return view === "2" ? "Published Seminar" : "Publish Seminar";
  if (pathname === "/Classroom") return view === "2" ? "Published Workshop" : "Publish Workshop";
  if (pathname === "/ProductManagement") return view === "2" ? "Pricing" : "Product Management";
  if (pathname === "/newFilecabinet") {
    if (view === "2") return "Assign Cabinet";
    return "File Cabinet";
}
  if (pathname === "/communication") return "Communications/Content";
  if (pathname === "/academyUsers") return "Academy Users";
  if (pathname === "/AllClients") return "Clients";
  if (pathname === "/Professional") return "Strategic Partners";
  if (pathname === "/Feedback") return "Feedback";
  if (pathname === "/productsAndPlans") return "Case Management";
  if (pathname === "/documentManagement") return "Document Management";
  if (pathname === "/Agreement") return "Agreement";
  if (pathname === "/DashBoard") return "Dashboard";
  if (pathname === "/agentsModule") return "Agent Module"
  return "Dashboard";
};

// ─── Chevron SVG (up / down) ────────────────────────────────────────────────

const ChevronIcon = ({ up }) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ flexShrink: 0 }}
  >
    {up ? (
      <path d="M2 8L6 4L10 8" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    ) : (
      <path d="M2 4L6 8L10 4" stroke="rgba(255,255,255,0.6)" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    )}
  </svg>
);

// ─── Hamburger SVG ──────────────────────────────────────────────────────────

const HamburgerIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 5H17" stroke="white" strokeWidth="1.8" strokeLinecap="round" />
    <path d="M3 10H17" stroke="white" strokeWidth="1.8" strokeLinecap="round" />
    <path d="M3 15H17" stroke="white" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

// ─── Tree wire + children ────────────────────────────────────────────────────
// One SVG spans ALL children:
//   • Single vertical line on the left running full height
//   • Straight horizontal branch (├) at midpoint of every non-last child row
//   • Rounded corner (└) at midpoint of the last child row
// Color #D8D8D8, stroke 1.4px — matches Figma exactly.

const WIRE_COLOR = "#D8D8D8";
const WIRE_STROKE = 1.4;
const ROW_HEIGHT = 37; // px — must match child row height

const ChildrenList = ({
  item,
  isChildItemActive,
  handleChildClick,
  CHILD_ACTIVE_BG,
  TEXT_COLOR,
  TEXT_MUTED,
}) => {
  const children = item.children;
  const count = children.length;
  const totalH = count * ROW_HEIGHT;

  // Wire geometry
  const svgW = 20;
  const vx = 4;          // x of vertical line
  const r = 10;          // corner radius for last child — generous curve to match Figma
  const branchEndX = svgW; // horizontal branch extends to right edge of SVG

  // Vertical line: from top to midpoint of last row
  const lastMidY = (count - 1) * ROW_HEIGHT + ROW_HEIGHT / 2;

  return (
    <div style={{ position: "relative" }}>
      {/* Full-width background rows — rendered behind wire+label */}
      <div style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, pointerEvents: "none" }}>
        {children.map((child, i) => {
          const childActive = isChildItemActive(item, child);
          return (
            <div
              key={`bg-${item.name}-${child.name}`}
              style={{
                height: `${ROW_HEIGHT}px`,
                background: childActive ? CHILD_ACTIVE_BG : "transparent",
                transition: "background 0.2s ease",
              }}
            />
          );
        })}
      </div>
      {/* Wire + labels row — laid on top */}
      <div style={{ display: "flex", flexDirection: "row", position: "relative" }}>

        {/* SVG wire with left padding */}
        <div style={{ paddingLeft: "22px", flexShrink: 0 }}>
          <svg
            width={svgW}
            height={totalH}
            viewBox={`0 0 ${svgW} ${totalH}`}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ display: "block" }}
          >
            {/* Vertical line — stops where last child curve begins */}
            <path
              d={`M ${vx} 0 L ${vx} ${lastMidY - r}`}
              stroke={WIRE_COLOR}
              strokeWidth={WIRE_STROKE}
              strokeLinecap="round"
            />
            {/* Rounded └ curve for every child */}
            {children.map((_, i) => {
              const midY = i * ROW_HEIGHT + ROW_HEIGHT / 2;
              return (
                <path
                  key={i}
                  d={`M ${vx} ${midY - r} Q ${vx} ${midY} ${vx + r} ${midY} H ${branchEndX}`}
                  stroke={WIRE_COLOR}
                  strokeWidth={WIRE_STROKE}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              );
            })}
          </svg>
        </div>

        {/* Clickable label rows */}
        <div style={{ flex: 1 }}>
          {children.map((child) => {
            const childActive = isChildItemActive(item, child);
            return (
              <div
                key={`${item.name}-${child.name}`}
                onClick={(e) => {
                  e.stopPropagation();
                  handleChildClick(item, child);
                }}
                title={child.name}
                style={{
                  display: "flex",
                  alignItems: "center",
                  height: `${ROW_HEIGHT}px`,
                  margin: 0,
                  paddingLeft: "6px",
                  paddingRight: "12px",
                  cursor: "pointer",
                  userSelect: "none",
                }}
              >
                <span
                  style={{
                    fontSize: "13px",
                    fontWeight: childActive ? 600 : 400,
                    color: childActive ? TEXT_COLOR : TEXT_MUTED,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    marginLeft:"14px"
                  }}
                >
                  {child.name}
                </span>
              </div>
            );
          })}
        </div>

      </div>
    </div>
  );
};

// ─── Component ──────────────────────────────────────────────────────────────

const SideMenue2 = () => {
  const [isOpen, setIsOpen] = useState(true);
  const [active, setActive] = useState("Dashboard");
  const [menuItems, setMenuItems] = useState([]);
  const [expandedGroups, setExpandedGroups] = useState({});
  const { setLoader,subtinentDetails,setSubtinentDetails } = useContext(UserContext)
  const navigate = useNavigate();
  const location = useLocation();

  const navigateToLink = (link, replace = false) => {
    const [pathname, query] = link.split("?");
    navigate({ pathname, search: query ? `?${query}` : "" }, { replace });
  };

  const syncActiveFromRoute = () => {
    const rId = sessionStorage.getItem("roleUserId");
    const { pathname, search } = location;

    if (pathname === FIRM_PARTNER_PATH && menuItems.length) {

      const view = new URLSearchParams(search).get("view");

      if (view === "7") {
        setActive("Manage File Cabinet");
        setExpandedGroups(prev => ({
          ...prev,
          "File Cabinet": true
        }));
        return;
      }

      const firmChild = getFirmActiveChild(menuItems, search);
      const firmParent = getFirmParentFromItems(menuItems);

      if (firmChild) setActive(firmChild.name);

      if (firmParent?.children?.length > 1) {
        setExpandedGroups(prev => ({
          ...prev,
          [firmParent.name]: true
        }));
      }

      return;
    }

    const nextActive = getActiveFromRoute(pathname, search, rId);
    setActive(nextActive);
    const parent = menuItems.find((item) => getItemPath(item) === pathname);
    if (parent?.children?.length > 1)
      setExpandedGroups((prev) => ({ ...prev, [parent.name]: true }));
  };
  function isDate1BeforeDate2(date1, date2) {
    if(!isNullUndefine(subtinentDetails)){
      const d1 = new Date(subtinentDetails?.createdOn);
      // const d1 = new Date("07/12/2026");
      const d2 = new Date("06/12/2026");
      return d1 < d2;
    }else{
      return false
    }
}


  useEffect(() => {
    if (isNullUndefine(subtinentDetails)) return; // ← wait until data is ready
    const rId = sessionStorage.getItem("roleUserId");
    const subtinentId = sessionStorage.getItem("subtenantId");
    const items = normalizeMenuItems(
      rId == 4 ? buildSuperAdminMenu(rId,subtinentId,isDate1BeforeDate2()) : buildFirmAdminMenu(rId,subtinentId,isDate1BeforeDate2())
    );
    setMenuItems(items);
    const firmParent = getFirmParentFromItems(items);
    if (firmParent?.children?.[0]) {
    setExpandedGroups({ [firmParent.name]: true });

    const view = new URLSearchParams(location.search).get("view");

    if (
        location.pathname === FIRM_PARTNER_PATH &&
        view !== "7"
    ) {
        setActive(firmParent.children[0].name);
    }
}
  }, [subtinentDetails]);

  useEffect(() => {
    if (location.pathname !== FIRM_PARTNER_PATH || !menuItems.length) return;
    const firmParent = getFirmParentFromItems(menuItems);
    const firstChild = firmParent?.children?.[0];
    if (!firstChild) return;
    const view = new URLSearchParams(location.search).get("view");
    const validViews = firmParent.children.map((c) => getViewFromChildLink(c.Link));
    const isValidView =   view === "7" || (view && validViews.some(v => String(v) === String(view)));
    if (!isValidView) navigateToLink(firstChild.Link, true);
  }, [location.pathname, location.search, menuItems]);

  useEffect(() => {
    if (!menuItems.length) return;
    syncActiveFromRoute();
  }, [location.pathname, location.search, menuItems]);

  const handleChildClick = (parentItem, child) => {
    if (child.analyticsAction) {
      const subtenantId = sessionStorage.getItem("subtenantId");
      setLoader(true);
      Services.getSubtenantDetail(subtenantId, true).then((res) => {
        const { subtenantName, subtenantLogoUrl } = res.data?.data?.[0] || {};
        let params = `subtenantId=${subtenantId}&subtenantName=${subtenantName}&subtenantLogoUrl=${subtenantLogoUrl}`;
        let encoded = window.btoa(params);
        const analyticsUrl = `https://${config?.demo == true ? "uat6." : ""}agingoptions.com/firm-dashboard/?subtenantId=${subtenantId}&expires=${1784200000}&token=${encoded}`;
        setLoader(false);
        window.open(analyticsUrl, "_blank");
      }).catch(() => {
        setLoader(false);
      });
      return;
    }
    setActive(child.name);
    navigateToLink(child.Link);
    setExpandedGroups((prev) => ({ ...prev, [parentItem.name]: true }));
  };

  const handleParentClick = (item) => {
    const hasChildren = item.children?.length > 1;
    if (!hasChildren) {
      setActive(item.name);
      navigateToLink(item.Link);
      return;
    }
    const isExpanded = !!expandedGroups[item.name];
    if (!isExpanded) {
      setExpandedGroups((prev) => ({ ...prev, [item.name]: true }));
      handleChildClick(item, item.children[0]);
      return;
    }
    setExpandedGroups((prev) => ({ ...prev, [item.name]: !prev[item.name] }));
  };

  const matchesChildLink = (childLink) => {
    const [childPath, childQuery = ""] = childLink.split("?");
    if (location.pathname !== childPath) return false;
    const childView = childQuery ? new URLSearchParams(childQuery).get("view") : null;
    const currentView = new URLSearchParams(location.search).get("view");
    if (!childQuery) return !location.search;
    if (childView && String(currentView) === String(childView)) return true;
    if (childView === "1" && !currentView) return true;
    return false;
  };


const isChildItemActive = (_, child) => {
  if (child.analyticsAction) return false;
  return matchesChildLink(child.Link);
};

 const hasActiveChild = (item) => {
  if (
    item.path === "/FirmPartner" &&
    new URLSearchParams(location.search).get("view") === "7"
  ) {
    return false;
  }
  return item.children?.some(child => isChildItemActive(item, child));
};

  const isTopLevelItemActive = (item) =>
    item.children?.length > 1 ? hasActiveChild(item) : active === item.name;

  // ─── Style tokens ──────────────────────────────────────────────────────────
  const SIDEBAR_BG = "#2b2b2e";
  const ACTIVE_BG  = "#720c20";
  const CHILD_ACTIVE_BG = "#411820";
  const TEXT_COLOR = "#ffffff";
  const TEXT_MUTED  = "rgba(255,255,255,0.60)";

  return (
    <div
      className="overFlowScroolsideMenu"
      style={{
        width: isOpen ? "260px" : "52px",
        minWidth: isOpen ? "230px" : "52px",
        height: "calc(100vh - 4.6rem)",
        background: SIDEBAR_BG,
        color: TEXT_COLOR,
        display: "flex",
        flexDirection: "column",
        overflowY: "auto",
        overflowX: "hidden",
        flexShrink: 0,
        transition: "width 0.28s ease, min-width 0.28s ease",
      }}
    >
      {/* ── Hamburger toggle ─── */}
      <div
        style={{
          display: "flex",
          justifyContent: isOpen ? "flex-end" : "center",
          padding: isOpen ? "12px 14px 10px" : "12px 0 10px",
          borderBottom: "1px solid rgba(255,255,255,0.08)",
        }}
      >
        <button
          onClick={() => setIsOpen((prev) => !prev)}
          title={isOpen ? "Collapse menu" : "Expand menu"}
          style={{
            background: "transparent",
            border: "none",
            cursor: "pointer",
            padding: "4px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <HamburgerIcon />
        </button>
      </div>

      {/* ── Menu items ─── */}
      <div style={{ flex: 1, paddingBottom: "16px" }}>
        {menuItems.map((item) => {
          const hasChildren = item.children?.length > 1;
          const isExpanded  = !!expandedGroups[item.name];
          const isParentActive = isTopLevelItemActive(item);

          return (
            <div key={item.name}>
              {/* Parent row */}
              <div
                onClick={() => !item.disabled && handleParentClick(item)}
                title={!isOpen ? item.name : undefined}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: isOpen ? "space-between" : "center",
                  padding: isOpen ? "11px 20px 11px 16px" : "12px 0",
                  cursor: item.disabled ? "not-allowed" : "pointer",
                  background: isParentActive && !item.disabled ? ACTIVE_BG : "transparent",
                  transition: "background 0.2s ease",
                  userSelect: "none",
                  position: "relative",
                  opacity: item.disabled ? 0.7 : 1,
                }}
              >
                {/* Left: icon + label */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    overflow: "hidden",
                  }}
                >
                  <img
                    src={item.icon}
                    alt=""
                    style={{
                      width: "20px",
                      height: "20px",
                      flexShrink: 0,
                      filter: item.disabled
                        ? "brightness(0) invert(0.45)"
                        : "brightness(0) invert(1)",
                    }}
                  />
                  {isOpen && (
                    <span
                      style={{
                        fontSize: "13.5px",
                        fontWeight: isParentActive && !item.disabled ? 700 : 400,
                        color: item.disabled ? "#737373" : (isParentActive ? TEXT_COLOR : TEXT_COLOR),
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {item.name}
                    </span>
                  )}
                </div>

                {/* Right: chevron */}
                {isOpen && hasChildren && (
                  <ChevronIcon up={isExpanded} />
                )}

                {/* Polygon 1 — white left-pointing triangle on right edge when active */}
                {isOpen && isParentActive && (
                  <img
                    src="/Polygon1.svg"
                    alt=""
                    style={{
                      position: "absolute",
                      right: "-1px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      width: "20px",
                      height: "20px",
                      pointerEvents: "none",
                    }}
                  />
                )}
              </div>

              {/* Children */}
              {isOpen && hasChildren && isExpanded && (
                <ChildrenList
                  item={item}
                  isChildItemActive={isChildItemActive}
                  handleChildClick={handleChildClick}
                  CHILD_ACTIVE_BG={CHILD_ACTIVE_BG}
                  TEXT_COLOR={TEXT_COLOR}
                  TEXT_MUTED={TEXT_MUTED}
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SideMenue2;
